import React from "react";

function InputDatoProdottoTextarea(props) {
        
    //const prodottoTemp=props.prodottoTemp;
    const inputLabel=props.inputLabel;
    const datoName=props.datoName;
    const datoId=props.datoId;
    const datoValue=props.datoValue;
    const datoPlaceHolder=props.datoPlaceHolder;
    const datoOnChange= props.datoOnChange;
    const datoClass= props.datoClass;
    const classiTastoSblocco = props.classiTastoSblocco;
    const tastoCopiaAspetto = props.tastoCopiaAspetto;

    
    
    
    
    
    return (
        <div className="mb1">
            <label for={datoId}
                className="pointer" 
                onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
            >{inputLabel}</label><br />
            <div><textarea 
                type="text" 
                rows="40" 
                cols="50" 
                id={datoId}
                name={datoName}
                value={datoValue}
                onChange={datoOnChange}
                className={datoClass} /><br />
            </div>
                                            
           {/*  <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button><br />   */}
        </div>
    )



}

export default InputDatoProdottoTextarea;